import Request from '@/lib/request.js'
import crypto from '@/lib/crypto.js'
import randomatic from 'randomatic'
import appConfig from '@/app.config.js'
import UserService from '@/lib/user.js'

import NoSleep from 'nosleep.js'
const noSleep = new NoSleep()

const platformAndroid = 'Android'
const playformApple = ['iPhone', 'iPod', 'iPad', 'iPhone Simulator', 'iPod Simulator', 'iPad Simulator', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K', 'Pike v7.6 release 92', 'Pike v7.8 release 517']

const isAndroid = navigator.appVersion.toString().indexOf(platformAndroid) > -1
const isApple = playformApple.toString().indexOf(navigator.platform) > -1

const authHeader = () => {
    const userService = new UserService
    const token = userService.getToken()

    return {
        'Authorization': `Bearer ${token}`,
    }
}

const getBaseImagePath = path => {

    if (path.indexOf('giphy.com') !== -1) {
        return path
    }

    return appConfig.baseUrl + path
}

export default {

    // Or create quiz
    createQuestion: function (context) {

        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        var quiz = context.state.question

        context.commit('toggleMainLoader', true)

        return new Promise((resolve, reject) => {
            quiz.captcha_response = context.state.captchaResponse

            request.post(appConfig.api.createQuiz, quiz)
                .then(function (res) {
                    context.dispatch('createQuizLogs', {
                        quiz_id: res.data.data._id,
                        action: 'create_quiz',
                        payload: {}
                    })

                    context.commit('updateQuestion', res.data.data)
                    context.commit('toggleMainLoader', false)
                    context.commit('updateCreateQuestionStatus', true)
                    context.commit('updateQrCodeUrl', res.data.data.code)

                    resolve(res.data.data)
                })
                .catch(function (err) {
                    context.commit('updateMainModalMessage', err.response.data.message)
                    context.commit('toggleMainModal', true)
                    context.commit('toggleMainLoader', false)
                    reject()
                })
        })
    },

    updateQuiz: function (context, customQuiz) {

        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        var quiz = context.state.question

        if (customQuiz && customQuiz.quiz) {
            quiz = customQuiz.quiz
        }

        context.commit('toggleMainLoader', true)

        return new Promise(function (resolve, reject) {
            quiz.captcha_response = context.state.captchaResponse

            request.put(appConfig.api.updateQuiz, quiz)
                .then(function (res) {

                    if (customQuiz && customQuiz.update) {
                        context.commit('updateQuestion', res.data.data)
                    }

                    context.commit('toggleMainLoader', false)
                    context.commit('updateQrCodeUrl', res.data.data.code)
                    resolve(res.data.data)
                })
                .catch(function (err) {

                    context.commit('updateMainModalMessage', err.response.data.message)
                    context.commit('toggleMainModal', true)
                    context.commit('toggleMainLoader', false)
                    reject()
                })
        })
    },

    updateQuizQuestion: function (context) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })
        const questions = context.state.question.questions

        return new Promise((resolve, reject) => {

            const url = appConfig.api.updateQuestion.replace('__id__', context.state.question._id)
            request.put(url, { questions })
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    fetchQuestionById: function (context, id) {

        const userService = new UserService
        const token = userService.getToken()

        var request = new Request({
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })

        context.commit('toggleMainLoader', true)

        return new Promise(function (resolve, reject) {

            var url = `${appConfig.api.fetchQuizById}${id}`

            if (context.getters.isActiveOnly) {
                url += '/play'
            }

            let options = {
                params: {}
            }

            if (context.state.isPreviewMode) {
                options['params']['mode'] = 'preview'
            }

            request.get(url, options)
                .then(function (res) {
                    context.commit('updateQuestion', res.data.data)
                    context.commit('toggleMainLoader', false)
                    context.commit('updateQrCodeUrl', res.data.data.code)

                    if (res.data.data.approval_status && ['pending', 'reject'].indexOf(res.data.data.approval_status) > -1) {
                        context.commit('toggleApproval', true)
                    }

                    if (res.data.data.show_school_list && [true].indexOf(res.data.data.show_school_list) > -1) {
                        context.commit('toggleShowSchoolList', true)
                    }


                    resolve(res)
                })
                .catch(function (err) {

                    if (err.response.status == 403) {
                        context.commit('toggleMainLoader', false)
                        return reject(err)
                    }

                    if (err.response.status >= 400) {
                        context.commit('toggleMainLoader', false)
                        return reject(err)
                    }

                    context.commit('updateMainModalMessage', err.response.data.message)
                    context.commit('toggleMainModal', true)
                    context.commit('toggleMainLoader', false)
                    reject()
                })
        })
    },

    fetchQuestionAndRandomById: function (context, extraParams) {

        const userService = new UserService
        const token = userService.getToken()

        var request = new Request({
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })

        context.commit('toggleMainLoader', true)

        return new Promise(function (resolve, reject) {

            var url = appConfig.api.fetchQuizAndRandomById.replace('__id__', extraParams.id)

            delete extraParams.id

            request.get(url, { params: extraParams })
                .then(function (res) {

                    context.commit('updateQuestion', res.data.data)
                    context.commit('toggleMainLoader', false)
                    context.commit('updateQrCodeUrl', res.data.data.code)

                    if (res.data.data.approval_status && ['pending', 'reject'].indexOf(res.data.data.approval_status) > -1) {
                        context.commit('toggleApproval', true)
                    }

                    if (res.data.data.show_school_list && [true].indexOf(res.data.data.show_school_list) > -1) {
                        context.commit('toggleShowSchoolList', true)
                    }

                    resolve(res)
                })
                .catch(function (err) {

                    if (err.response.status == 403) {
                        context.commit('toggleMainLoader', false)
                        return reject(err)
                    }

                    if (err.response.status >= 400) {
                        context.commit('toggleMainLoader', false)
                        return reject(err)
                    }

                    context.commit('updateMainModalMessage', err.response.data.message)
                    context.commit('toggleMainModal', true)
                    context.commit('toggleMainLoader', false)
                    reject()
                })
        })
    },

    fetchImageSearch(context, key) {

        var request = new Request

        return new Promise((resolve, reject) => {

            let url = `${appConfig.api.fetchImageSearch}`

            let param = {
                q: key || ""
            }

            request.post(url, param)
                .then((res) => {
                    if (res.status === 200) {
                        context.commit('updateImageSearch', res.data.data)
                        resolve()
                    } else {
                        reject()
                    }

                })
                .catch(() => {
                    reject()
                })
        })
    },

    fetchServerImage(context, data) {
        var request = new Request

        return new Promise((resolve, reject) => {

            const url = `${appConfig.api.generateImageSearch}`

            request.post(url, data, { timeout: 8000 })
                .then((res) => {
                    let myFile

                    if (res.status === 200) {
                        myFile = {
                            img_url: res.data.data.img_url,
                            source: res.data.data.source,
                            external: true
                        }
                    } else {
                        myFile = {
                            img_url: data.thumbnail,
                            source: data.source,
                            external: true
                        }
                    }

                    context.commit('updateServerImageSelect', myFile)
                    resolve(myFile)

                })
                .catch(e => {
                    reject(e)
                })
        })
    },

    uploadQuizImage: function (context, formData) {

        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        context.commit('updateUploadQuizImageStatus', true)

        return new Promise(function (resolve, reject) {
            request.post(appConfig.api.uploadImage, formData)
                .then(function (res) {

                    var imagePath = getBaseImagePath(res.data.data.upload_path)
                    context.commit('updateQuizImage', imagePath)
                    context.commit('updateUploadQuizImageStatus', false)
                    resolve()
                })
                .catch(function (err) {

                    var errorMessage = err.response.data.message

                    context.commit('updateQuizImage', '')
                    context.commit('updateMainModalMessage', errorMessage)
                    context.commit('toggleMainModal', true)
                    context.commit('updateUploadQuizImageStatus', false)
                    reject()
                })
        })

    },

    uploadThemeBgImage: function (context, { formData, coordinates }) {

        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        return new Promise((resolve, reject) => {
            request.post(appConfig.api.uploadImage, formData)
                .then(function (res) {

                    const imagePath = getBaseImagePath(res.data.data.upload_path)
                    const themes = context.getters.themes
                    const themeName = context.getters.themeName

                    themes[themeName].background_image = imagePath
                    themes[themeName].background_image_coordinates = coordinates

                    context.commit('setThemes', themes)
                    resolve()
                })
                .catch(function (err) {

                    var errorMessage = err.response.data.message
                    context.commit('updateMainModalMessage', errorMessage)
                    context.commit('toggleMainModal', true)
                    reject()
                })

        })

    },

    uploadOriginalThemeBgImage: function (context, formData) {
        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        return new Promise((resolve, reject) => {
            request.post(appConfig.api.uploadImage, formData)
                .then(function (res) {

                    const imagePath = getBaseImagePath(res.data.data.upload_path)
                    const themes = context.getters.themes
                    const themeName = context.getters.themeName

                    themes[themeName].background_image_original = imagePath

                    context.commit('setThemes', themes)
                    resolve()
                })
                .catch(function (err) {

                    var errorMessage = err.response.data.message
                    context.commit('updateMainModalMessage', errorMessage)
                    context.commit('toggleMainModal', true)
                    reject()
                })
        })
    },

    uploadQuizOriginalImage: function (context, formData) {

        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        context.commit('updateUploadQuizImageStatus', true)


        return new Promise((resolve, reject) => {
            request.post(appConfig.api.uploadImage, formData)
                .then(function (res) {

                    var imagePath = getBaseImagePath(res.data.data.upload_path)
                    context.commit('updateQuizOriginalImage', imagePath)
                    context.commit('updateUploadQuizImageStatus', false)
                    resolve()
                })
                .catch(function (err) {

                    var errorMessage = err.response.data.message

                    context.commit('updateQuizImage', '')
                    context.commit('updateMainModalMessage', errorMessage)
                    context.commit('toggleMainModal', true)
                    context.commit('updateUploadQuizImageStatus', false)
                    reject()
                })
        })

    },

    uploadQuizVideo: function (context, formData) {
        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        context.commit('updateUploadQuizVideoStatus', true)

        request.post(appConfig.api.uploadImage, formData)
            .then(function (res) {
                var videoPath = appConfig.baseUrl + res.data.data.upload_path

                context.commit('updateQuizVideo', videoPath)
                context.commit('updateUploadQuizVideoStatus', false)
            })
            .catch(function (err) {

                var errorMessage = err.response.data.message

                context.commit('updateQuizVideo', '')
                context.commit('updateMainModalMessage', errorMessage)
                context.commit('toggleMainModal', true)
                context.commit('updateUploadQuizVideoStatus', false)
            })
    },

    uploadBackgroundImage: function (context, formData) {

        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        context.commit('updateUploadBgImageStatus', true)

        return new Promise((resolve, reject) => {
            request.post(appConfig.api.uploadImage, formData)
                .then(function (res) {

                    var imagePath = getBaseImagePath(res.data.data.upload_path)

                    context.commit('updateUploadBgImageStatus', false)
                    context.commit('updateBackgroundImage', imagePath)
                    resolve()

                })
                .catch(function (err) {

                    var errorMessage = err.response.data.message

                    context.commit('updateBackgroundImage', '')
                    context.commit('updateMainModalMessage', errorMessage)
                    context.commit('toggleMainModal', true)
                    reject()
                })
        })
    },

    uploadQuizBackgroundOriginalImageFile: function (context, formData) {

        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        // context.commit('updateUploadQuizImageStatus', true)

        request.post(appConfig.api.uploadImage, formData)
            .then(function (res) {

                var imagePath = getBaseImagePath(res.data.data.upload_path)
                context.commit('updateQuizOriginalBackgroundImage', imagePath)
                // context.commit('updateUploadQuizImageStatus', false)
            })
            .catch(function (err) {

                var errorMessage = err.response.data.message

                context.commit('updateQuizBackgroundImage', '')
                context.commit('updateMainModalMessage', errorMessage)
                context.commit('toggleMainModal', true)
                context.commit('updateUploadQuizImageStatus', false)
            })
    },

    uploadQuestionImage: function (context, { formData, questionIndex, params }) {
        const url = new URL(appConfig.api.uploadImage)
        params = params || {}

        for (const item in params) {
            url.searchParams.set(item, params[item])
        }

        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        return new Promise(function (resolve, reject) {
            request.post(url.toString(), formData)
                .then(function (res) {

                    var imagePath = getBaseImagePath(res.data.data.upload_path)

                    context.commit('updateQuestionImage', {
                        questionIndex,
                        imagePath
                    })

                    resolve()

                })
                .catch(function (err) {

                    var errorMessage = err.response.data.message

                    context.commit('updateQuestionImage', {
                        questionIndex,
                        imagePath: ''
                    })

                    context.commit('updateMainModalMessage', errorMessage)
                    context.commit('toggleMainModal', true)

                    reject()
                })
        })
    },

    uploadQuestionOriginalImage: function (context, { formData2, questionIndex }) {

        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        return new Promise(function (resolve, reject) {
            request.post(appConfig.api.uploadImage, formData2)
                .then(function (res) {

                    var original = getBaseImagePath(res.data.data.upload_path)
                    context.commit('updateQuestionOriginalImage', {
                        questionIndex,
                        original
                    })

                    resolve()

                })
                .catch(function (err) {

                    var errorMessage = err.response.data.message

                    context.commit('updateQuestionOriginalImage', {
                        questionIndex,
                        original: ''
                    })

                    context.commit('updateMainModalMessage', errorMessage)
                    context.commit('toggleMainModal', true)

                    reject()
                })
        })
    },

    uploadAnswerImage: function (context, { formData, questionIndex, answerIndex }) {

        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        return new Promise(function (resolve, reject) {
            request.post(appConfig.api.uploadImage, formData)
                .then(function (res) {

                    var imagePath = getBaseImagePath(res.data.data.upload_path)

                    context.commit('updateAnswerImage', {
                        questionIndex,
                        answerIndex,
                        imagePath
                    })

                    resolve()

                })
                .catch(function (err) {

                    var errorMessage = err.response.data.message

                    context.commit('updateAnswerImage', {
                        questionIndex,
                        answerIndex,
                        imagePath: ''
                    })

                    context.commit('updateMainModalMessage', errorMessage)
                    context.commit('toggleMainModal', true)

                    reject()
                })
        })
    },

    uploadAnswerOriginalImage: function (context, { formData2, questionIndex, answerIndex }) {

        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        return new Promise(function (resolve, reject) {
            request.post(appConfig.api.uploadImage, formData2)
                .then(function (res) {

                    var original = getBaseImagePath(res.data.data.upload_path)
                    context.commit('updateAnswerOriginalImage', {
                        questionIndex,
                        answerIndex,
                        original
                    })

                    resolve()

                })
                .catch(function (err) {

                    var errorMessage = err.response.data.message

                    context.commit('updateAnswerOriginalImage', {
                        questionIndex,
                        answerIndex,
                        original: ''
                    })

                    context.commit('updateMainModalMessage', errorMessage)
                    context.commit('toggleMainModal', true)

                    reject()
                })
        })
    },

    uploadQuestionVideo: function (context, { formData, questionIndex }) {

        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        return new Promise(function (resolve, reject) {
            request.post(appConfig.api.uploadImage, formData)
                .then(function (res) {

                    var videoPath = getBaseImagePath(res.data.data.upload_path)

                    context.commit('updateQuestionVideo', {
                        questionIndex,
                        videoPath
                    })

                    resolve()

                })
                .catch(function (err) {

                    var errorMessage = err.response.data.message

                    context.commit('updateQuestionVideo', {
                        questionIndex,
                        videoPath: ''
                    })

                    context.commit('updateMainModalMessage', errorMessage)
                    context.commit('toggleMainModal', true)

                    reject()
                })
        })
    },

    uploadAnswerVideo: function (context, { formData, questionIndex, answerIndex }) {

        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        return new Promise(function (resolve, reject) {
            request.post(appConfig.api.uploadImage, formData)
                .then(function (res) {

                    var videoPath = appConfig.baseUrl + res.data.data.upload_path

                    context.commit('updateAnswerVideo', {
                        questionIndex,
                        answerIndex,
                        videoPath
                    })

                    resolve()

                })
                .catch(function (err) {

                    var errorMessage = err.response.data.message

                    context.commit('updateAnswerVideo', {
                        questionIndex,
                        answerIndex,
                        videoPath: ''
                    })

                    context.commit('updateMainModalMessage', errorMessage)
                    context.commit('toggleMainModal', true)

                    reject()
                })
        })
    },

    handleNextResult: function (context) {

        var nextQuizIndex = context.state.playingCurrentQuestionIndex + 1,
            questionCount = context.state.question.questions.length - 1

        context.commit('updateCurrentQuizIndex', nextQuizIndex)
        context.commit('updateIsEndQuiz', nextQuizIndex == questionCount)
    },

    fetchQuestionByQuizCode: function (context, extraParams) {

        var request = new Request
        var url = appConfig.api.fetchQuestionByQuizCode.replace('__code__', extraParams.code)

        context.commit('toggleMainLoader', true)

        return new Promise(function (resolve, reject) {
            delete extraParams.code
            request.get(url, { params: extraParams })
                .then(function (res) {

                    var quiz = JSON.stringify(res.data.data)
                    quiz = crypto.dec(quiz)

                    context.commit('updateQuestion', res.data.data)
                    context.commit('player/updateQuiz', quiz)
                    context.commit('toggleMainLoader', false)
                    resolve(quiz)
                })
                .catch(function (err) {

                    if (err.response) {
                        context.commit('updateMainModalMessage', err.response.data.message)
                    }
                    context.commit('toggleMainModal', true)
                    context.commit('toggleMainLoader', false)
                    reject()
                })
        })
    },

    enableNoSleep: function (context) {
        if (isAndroid) {
            noSleep.enable()
        }

        if (isApple) {
            context.getters.getSilenceAudio.play()
            context.commit('updateIntervalNoSleep', setInterval(() => {
                context.getters.getSilenceAudio.play()
            }, 2000))
        }
    },

    pauseNoSleep: function (context) {
        clearInterval(context.getters.getIntervalNoSleep)
        context.getters.getSilenceAudio.pause()
        context.commit('updateIntervalNoSleep', null)
    },

    disableNoSleep: function (context) {
        if (isAndroid) {
            noSleep.disable()
        }

        if (isApple) {
            clearInterval(context.getters.getIntervalNoSleep)
            context.getters.getSilenceAudio.remove()
            context.commit('updateIntervalNoSleep', null)
        }
    },

    fetchFrontPageSetting: function (context) {
        var request = new Request({
            baseURL: appConfig.cacheSetting ? appConfig.apiBaseUrl.replace(/api\//, '') : appConfig.apiBaseUrl
        })
        var url = appConfig.api.fetchFrontPageSetting

        context.commit('toggleMainLoader', true)

        return new Promise(function (resolve, reject) {

            request.get(url)
                .then(function (res) {
                    context.commit('setSystemSetting', res.data.data) //add this because don't need to create a new request

                    let data = res.data.data
                    let background_color = typeof data.background_color !== 'undefined' ? data.background_color.content : null
                    let background_image = typeof data.background_image !== 'undefined' ? data.background_image.content : null
                    let background_type = typeof data.background_type !== 'undefined' ? data.background_type.content : null
                    let cookieConsent = typeof data.cookie_consent_setting !== 'undefined' ? data.cookie_consent_setting.content : null

                    let setting = {
                        background_color: background_color,
                        background_image: background_image,
                        background_type: background_type,
                        nav_text: background_color,
                        cookie_consent_setting: cookieConsent
                    }

                    context.commit('updateFrontPageSetting', setting)
                    context.commit('toggleMainLoader', false)

                    const evt = new CustomEvent('setting-loaded', {
                        detail: { setting }
                    })
                    window.dispatchEvent(evt)

                    resolve(setting)
                })
                .catch(function (err) {

                    context.commit('updateMainModalMessage', err.response.data.message)
                    context.commit('toggleMainModal', true)
                    context.commit('toggleMainLoader', false)
                    reject()
                })
        })
    },

    getSystemSettings: function () {
        const request = new Request({
            baseURL: appConfig.cacheSetting ? appConfig.apiBaseUrl.replace(/api\//, '') : appConfig.apiBaseUrl
        })

        const url = appConfig.api.fetchFrontPageSetting

        return new Promise(function (resolve, reject) {
            request.get(url)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    },

    findOrderAbility: function (ctx) {
        return new Promise(function () {
            const userService = new UserService
            const token = userService.getToken()

            const request = new Request({
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })

            request.get(appConfig.api.findOrderAbility)
                .then(res => {
                    ctx.commit('setOrderAbility', res.data.data)
                })
        })
    },

    saveQuizPlaying: function (context, data) {

        var request = new Request
        var url = appConfig.api.saveQuizPlaying.replace(/__id__/, data.quiz_id)

        return new Promise(function (resolve, reject) {
            request.post(url, data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    },

    sendEmailQuizPlayLive: function (context, data) {
        var request = new Request({
            headers: {
                ...authHeader()
            }
        });

        return new Promise(function (resolve, reject) {
            request.post(appConfig.api.sendEmailQuizPlayLive, data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    },

    getQuizPlaying: function (context, data) {

        var request = new Request
        var url = appConfig.api.getQuizPlaying.replace(/__id__/, data._id.$oid)

        return new Promise(function (resolve, reject) {
            request.get(url, data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    },

    validateSubscription: function () {
        const userService = new UserService
        const token = userService.getToken()
        const url = appConfig.api.validateSubscription

        const request = new Request({
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })

        return new Promise(function (resolve, reject) {
            request.get(url)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    },

    // eslint-disable-next-line
    getCurrentCountry: function (context) {
        const request = new Request
        const url = appConfig.api.getUserCountry

        return new Promise(function (resolve, reject) {
            request.get(url)
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    },

    getQuizRelateCategory: function (context, data) {
        const request = new Request
        const url = appConfig.api.getQuizRelateCategory
        const ctx = context;

        ctx.commit('setRelateQuiz', []);

        return new Promise(function (resolve, reject) {
            request.get(url, { params: { data: data } })
                .then((res) => {
                    ctx.commit('setRelateQuiz', res.data.data);
                    resolve(res)
                })
                .catch((err) => {
                    ctx.commit('setRelateQuiz', []);
                    reject(err)
                });
        });
    },

    uploadProfileImage: function (context, formData) {

        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        return new Promise(function (resolve, reject) {
            request.post(appConfig.api.uploadImage, formData)
                .then(function (res) {
                    var imagePath = appConfig.baseUrl + res.data.data.upload_path
                    resolve(imagePath)
                })
                .catch(function (err) {
                    reject(err)
                })
        })
    },

    cacheSpotifySong: function (context, payload) {

        const userService = new UserService
        const token = userService.getToken()
        const request = new Request({
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })

        return new Promise(function (resolve, reject) {
            request.post(appConfig.api.cacheSpotifySong, payload)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    },

    refreshToken: function () {
        const userService = new UserService
        const token = userService.getToken()
        const request = new Request({
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })

        return new Promise(function (resolve, reject) {
            request.post(appConfig.api.refreshToken)
                .then(res => {
                    const userService = new UserService
                    userService.setToken(res.data.data.token)
                    resolve()
                })
                .catch(err => reject(err))
        })
    },

    applyToCreator: function () {
        const userService = new UserService
        const token = userService.getToken()
        const request = new Request({
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })

        return new Promise(function (resolve, reject) {
            request.post(appConfig.api.applyToCreator)
                .then(() => {
                    resolve()
                })
                .catch(err => reject(err))
        })
    },

    getCredit: function (context) {
        const userService = new UserService
        const token = userService.getToken()
        const request = new Request({
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        const url = appConfig.api.getCredit.replace('__id__', userService.getUser().id)

        return new Promise(function (resolve, reject) {
            request.get(url)
                .then((res) => {
                    resolve(res.data)
                    if (res.data.data.credit !== undefined) {
                        context.commit('setUserCredit', res.data.data.credit)
                    }
                })
                .catch(err => reject(err))
        })
    },

    saveCoin: function (context, data) {
        const userService = new UserService
        const token = userService.getToken()
        const coinToken = randomatic('Aa0', 20)
        const request = new Request({
            headers: {
                'Authorization': `Bearer ${token}`,
                'VerifyToken': coinToken
            }
        })

        const url = appConfig.api.saveCoin

        return new Promise(function (resolve, reject) {
            request.post(url, {
                totalCoin: data
            })
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    },

    createLog: function (context, data) {
        const userService = new UserService
        const token = userService.getToken()
        const request = new Request({
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        const url = appConfig.api.createLog

        return new Promise(function (resolve, reject) {
            request.post(url, data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    },

    createStripeCharge: function (context, data) {
        const userService = new UserService
        const token = userService.getToken()
        const request = new Request({
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })

        const url = appConfig.api.createStripeCharge

        return new Promise(function (resolve, reject) {
            request.post(url, data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    },

    validateStripeCaptcha: function (context, data) {
        const userService = new UserService();
        const token = userService.getToken();
        const request = new Request({
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        const url = appConfig.api.validateCaptcha;

        return new Promise(function (resolve, reject) {
            request.post(url, data)
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    },

    createPaymentIntent: function (context, data) {
        const userService = new UserService();
        const token = userService.getToken();
        const request = new Request({
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        const url = appConfig.api.createPaymentIntent;

        return new Promise(function (resolve, reject) {
            request.post(url, data)
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    },

    // eslint-disable-next-line
    cancelPaymentIntent: function (context) {
        const userService = new UserService();
        const token = userService.getToken();
        const request = new Request({
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        const url = appConfig.api.removePaymentIntent;

        return new Promise(function (resolve, reject) {
            request.get(url)
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    },

    findCategoryScore: function (context, data) {
        const userService = new UserService();
        const token = userService.getToken();
        var request = new Request({
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        const url = appConfig.api.categoryScore.replace(/__id__/, data.user_id)
        delete data.user_id;

        return new Promise(function (resolve, reject) {
            request.post(url, data)
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    },

    createSponsorQuizShareLink: function (context, data) {
        var request = new Request({
            headers: {
                ...authHeader()
            }
        });

        return new Promise(function (resolve, reject) {
            request.post(appConfig.api.createSponsorQuizShareLink, data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    },

    sendCreateEmail: function (context, data) {
        var request = new Request({
            headers: {
                ...authHeader()
            }
        });

        return new Promise(function (resolve, reject) {
            request.post(appConfig.api.sendCreateEmail, data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    },

    setStatusFreeTrial: function (context, data) {
        const request = new Request({
            headers: {
                ...authHeader()
            },
        });

        const url = appConfig.api.setStatusFreeTrial;
        return new Promise(function (resolve, reject) {
            request.post(url, data)
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    },

    getStatusFreeTrial: function (context, data) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        const url = appConfig.api.getStatusFreeTrial.replace(/__token__/, data.token)
        return new Promise(function (resolve, reject) {
            request.get(url, data)
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    },

    resendToEmail: function (context, data) {
        const request = new Request({
            headers: {
                ...authHeader()
            },
        });

        const url = appConfig.api.resendToEmail;
        return new Promise(function (resolve, reject) {
            request.post(url, data)
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    },

    getCouponStatus: function (context, data) {
        const request = new Request({
            headers: {
                ...authHeader()
            },
        });

        const url = appConfig.api.getCouponStatus;
        return new Promise(function (resolve, reject) {
            request.get(url, { params: data })
                .then((res) => resolve(res))
                .catch((err) => {
                    console.log(err)
                    reject(err)
                });
        });
    },

    getSchoolSubjectById: function (ctx, id) {
        const request = new Request({
            headers: {
                ...authHeader()
            },
        });

        var url = appConfig.api.getSchoolSubjectById.replace(/__id__/, id)

        return new Promise(function (resolve, reject) {
            request.get(url)
                .then((res) => {
                    let subjects = res.data.data
                    let dataSubjects = []
                    for (let index in subjects) {
                        if (subjects[index].status) {
                            dataSubjects.push(subjects[index]);
                        }
                    }

                    ctx.commit('setSchoolSubject', dataSubjects);
                    resolve(res)
                })
                .catch((err) => {
                    ctx.commit('setSchoolSubject', []);
                    reject(err)
                });
        })
    },

    toggleQuizStatus: function (ctx, id) {
        const request = new Request({
            headers: {
                ...authHeader()
            },
        });

        var url = appConfig.api.toggleQuizStatus.replace(/__id__/, id)

        return new Promise(function (resolve, reject) {
            request.post(url)
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        })
    },

    checkUpdateShowOneTimeOffer: function () {
        const request = new Request({
            headers: {
                ...authHeader()
            },
        });

        var url = appConfig.api.checkUpdateShowOneTimeOffer

        return new Promise(function (resolve, reject) {
            request.get(url)
                .then(resolve)
                .catch(reject);
        })
    },

    getShowOneTimeOffer: function () {
        const request = new Request({
            headers: {
                ...authHeader()
            },
        });

        var url = appConfig.api.getShowOneTimeOffer

        return new Promise(function (resolve, reject) {
            request.get(url)
                .then(resolve)
                .catch(reject);
        })
    },

    getLimitAiQuestion: function (context) {
        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        return new Promise((resolve, reject) => {

            const url = appConfig.api.getLimitAiQuestionByUser
            request.post(url)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    getLimitAiImage: function (context) {
        var request = new Request({
            headers: {
                'Content-Type': 'multipart/form-data',
                ...authHeader()
            }
        })

        return new Promise((resolve, reject) => {

            const url = appConfig.api.getLimitAiImageByUser
            request.post(url)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    setAiImageByUser: function (context, data) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise((resolve, reject) => {

            const url = appConfig.api.setAiImageByUser

            request.put(url, data)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    setAiQuestionByUser: function (context, data) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise((resolve, reject) => {

            const url = appConfig.api.setAiQuestionByUser

            request.put(url, data)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    switchAccount: function (context, data) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise((resolve, reject) => {
            const url = appConfig.api.switchAccount

            request.post(url, data)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    getUserInSchool: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.getUserInSchool

            request.get(url, payload)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    updateSchoolUserStatus: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.updateSchoolUserStatus

            request.post(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
            setTimeout(() => {
                resolve(true)
            }, 500)
        })
    },

    inviteUsers: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.inviteUsers

            request.post(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    getSchoolMyQuizzes: function (context, payload) {
        payload.params = encodeURIComponent(JSON.stringify(payload.params))

        let url = new URL(appConfig.api.schoolMyQuizzes)

        for (const item in payload) {
            url.searchParams.set(item, payload[item])
        }

        url = decodeURIComponent(url)

        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            request.get(url)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    removeQuizFromLibrary: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.removeQuizFromLibrary

            request.post(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    getSubjects: function () {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.getSubjects

            request.get(url)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    updateSubjects: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.updateSubjects

            request.patch(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    updateSchool: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.updateSchool

            request.patch(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    updateSchoolAdminStatus: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.updateSchoolAdminStatus

            request.post(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    getSchoolRequests: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            request.get(appConfig.api.getSchoolRequests, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    addToSchool: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.addToSchool

            request.post(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    inviteToSchool: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.inviteToSchool

            request.post(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    rejectAccessSchool: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.rejectAccessSchool

            request.post(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    copyToMyQuiz: function (context, { id, captcha_response, title }) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        const url = appConfig.api.copyToMyQuiz.replace(/__id__/, id)

        return new Promise((resolve, reject) => {
            request.post(url, { captcha_response })
                .then(res => {
                    context.dispatch('createQuizLogs', {
                        quiz_id: res.data.data._id,
                        action: 'clone_quiz',
                        payload: {
                            title
                        }
                    })

                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    createSchoolWhitelist: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        const url = appConfig.api.createSchoolWhitelist

        return new Promise((resolve, reject) => {
            request.post(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    updateSchoolWhitelist: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        const url = appConfig.api.updateSchoolWhitelist.replace(/__id__/, payload.id)

        return new Promise((resolve, reject) => {
            request.put(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    getSchoolWhitelist: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            request.get(appConfig.api.getSchoolWhitelist, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    getSchoolWhitelistAll: function () {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            request.get(appConfig.api.getSchoolWhitelistAll)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    deleteSchoolWhitelist: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.deleteSchoolWhitelist.replace(/__id__/, payload.id)

            request.delete(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    cloneSchoolWhitelist: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.cloneSchoolWhitelist.replace(/__id__/, payload.id)

            request.post(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    getQuizLogs: function (context, payload) {
        let url = new URL(appConfig.api.getQuizLogs.replace(/__id__/, payload.id))

        url.searchParams.set('page', payload.page)

        url = decodeURIComponent(url)

        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            request.get(url)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    createQuizLogs: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.createQuizLogs

            request.post(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    updateShareSetting: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.updateShareSetting.replace(/__id__/, payload.id)

            request.patch(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })

    },

    getMergeReports: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            request.get(appConfig.api.getMergeReports, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    getMergeReportById: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.getMergeReportById.replace(/__id__/, payload.id)

            request.get(url)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    createMergeReport: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.createMergeReport

            request.post(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    updateMergeReport: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.updateMergeReport.replace(/__id__/, payload.id)

            request.put(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    deleteMergeReport: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.deleteMergeReport.replace(/__id__/, payload.id)

            request.delete(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    updateMergeReportStatus: function (context, payload) {
        const request = new Request({
            headers: {
                ...authHeader()
            }
        })

        return new Promise(async (resolve, reject) => {
            const url = appConfig.api.updateMergeReportStatus.replace(/__id__/, payload.id)

            request.patch(url, payload)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
}
